const appeaReportMage = r => require.ensure([], () => r(require('@/page/appeaReport/appeaReportMage')), 'appeaReportMage');
const appeaReport = r => require.ensure([], () => r(require('@/page/appeaReport/appeaReport')), 'appeaReport');


const expertInfoRouter = {
    path: '',
    name: '报表填报',
    component: appeaReportMage,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive:false,
    },
    children: [{
        path: '/appeaReport',
        component: appeaReport,
        name: '报表列表',
        meta: {
            right: ['报表列表'],
            isShowMenu: true,
            keepAlive:true,
        },
    }]
};
export default expertInfoRouter;